import React from 'react';

const GameLanding = ({ game }) => {
  if (!game) return <div>Game not found.</div>;
  return (
    <div style={{ maxWidth: 600, margin: '0 auto', textAlign: 'center' }}>
      <h2>{game.title}</h2>
      {game.image && <img src={game.image} alt={game.title} style={{ maxWidth: '100%', height: 'auto', marginBottom: 20 }} />}
      <p>{game.description}</p>
    </div>
  );
};

export default GameLanding; 